import { motion } from "framer-motion";
import {
  FiMapPin,
  FiMail,
  FiPhone,
  FiClock,
} from "react-icons/fi";

export default function ContactUs() {
  const contactInfo = [
    {
      icon: <FiMapPin className="text-4xl text-orange-500" />,
      title: "Location",
      details: "Block No-301, Balaji Heights Jay Nagar, Belagavi, Karnataka, 591108",
    },
    {
      icon: <FiMail className="text-4xl text-orange-500" />,
      title: "Email",
      details: "hr@x7ittechnologies.com",
    },
    {
      icon: <FiPhone className="text-4xl text-orange-500" />,
      title: "Phone",
      details: "+91 7204439777",
    },
    {
      icon: <FiClock className="text-4xl text-orange-500" />,
      title: "Working Hours",
      details: (
        <>
          Mon to Sat : 10:00 AM – 7:00 PM <br /> Sun : Holiday
        </>
      ),
    },
  ];

  return (
    <>
      {/* CONTACT INFO CARDS */}
      <section className="bg-white py-20 px-6 md:px-16 mt-14">
        <div className="text-center mt-5 mb-16">
        <motion.h2
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-5xl font-extrabold text-gray-800 mb-4"
        >
         Get In Touch <span className="text-orange-500">With Us</span>
        </motion.h2></div>
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-14">
          {contactInfo.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.2 }}
              whileHover={{ scale: 1.05 }}
              className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl shadow-md p-8 text-center hover:shadow-lg transition-all duration-500 border border-gray-300"
            >
              <div className="flex justify-center mb-4">{item.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed break-words break-all">
                {item.details}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="w-full h-[450px] md:h-[550px]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.0273261468587!2d74.48344567447631!3d15.870320484780754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbf656008761ea1%3A0x7699c17559d622c8!2sX7%20DIGI%20ADS!5e1!3m2!1sen!2sin!4v1759770323046!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          className="w-full h-full border-0"
        ></iframe>
      </section>

      {/* JOIN US CTA SECTION */}
      <motion.section
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="py-20 px-6 md:px-16 bg-gray-600 text-white text-center rounded-tl-3xl rounded-tr-3xl mt-12"
      >
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Join Us On Our Journey
        </h2>
        <p className="mb-6 max-w-2xl mx-auto text-gray-200">
          We are always looking for talented individuals to be part of our
          growing team. Together, we achieve greatness.
        </p>
        <a href="https://www.linkedin.com/company/x7-it-technologies/" target="_blank" rel="noopener noreferrer">
        <button className="bg-white text-orange-500 font-semibold px-8 py-3 rounded-full hover:bg-gray-100 transition-transform hover:scale-105 duration-300">
          Contact Us
        </button>
        </a>
      </motion.section>
    </>
  );
}
